export default __webpack_public_path__ + "static/about-us-sustainability--mobile-2bc0c9fdd76c90fc467dac0f789436ed.jpg";